import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onesevanurbaniahireinpune() {



  const cardData =
  {
    keyword: '17 Seater Urbania Hire in Pune',
    heading: 'Amruta Travels: 17 Seater Urbania Hire in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers 17 Seater Urbania Hire in Pune for those who desire luxurious, spacious, and reliable group transportation. Ideal for corporate outings, family vacations, religious yatras, and airport transfers, our 17-seater Urbania vans ensure a premium travel experience with plush seating, strong air conditioning, and modern amenities. Each vehicle is meticulously maintained and driven by uniformed, professional chauffeurs who prioritize safety, comfort, and punctuality. Whether your journey takes you across Pune or to outstation destinations like Shirdi, Nashik, or Goa, Amruta Travels’ 17 Seater Urbania on Hire in Pune guarantees a smooth, elegant, and stress-free ride for every traveler.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 by the Peshwas of the Maratha Empire. Once the royal residence of Bajirao I, it reflects the grandeur of Maratha architecture with its massive gates, fountains, and gardens. The evening light and sound show brings history to life. Shaniwar Wada remains a must-visit heritage site that tells the glorious tale of Pune’s royal past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a symbol of India’s freedom struggle and a masterpiece of Indo-Islamic architecture. Built in 1892 by Sultan Muhammed Shah Aga Khan III, it served as a prison for Mahatma Gandhi and his wife Kasturba during the Quit India Movement. The museum inside preserves rare photos and personal belongings of Gandhi. It stands today as Pune’s monument of peace and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched atop the Sahyadri hills, is a historical fortress famous for the valor of Tanaji Malusare. The fort offers breathtaking panoramic views of the surrounding valleys and is a popular trekking destination. Ancient ruins, cannons, and the Tanaji memorial make it a must-see for history lovers. Sinhagad Fort is Pune’s majestic reminder of Maratha bravery."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s spiritual heart, attracting devotees from across India. The temple’s beautifully adorned idol of Lord Ganesha is known for its grandeur and divine presence. During Ganesh Chaturthi, the area transforms into a dazzling festival of lights, music, and devotion. It’s a sacred landmark representing Pune’s deep-rooted faith and cultural pride."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is a serene escape in Pune offering panoramic city views and spiritual calm. The hilltop temple complex, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. The 108-step climb rewards visitors with peace and stunning sunsets. Parvati Hill combines Pune’s heritage, spirituality, and scenic beauty in one tranquil experience."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple carved from basalt stone, dedicated to Lord Shiva. The temple’s circular Nandi mandapa and stone pillars showcase ancient Indian craftsmanship. Located in the city center, it offers a quiet retreat from urban hustle. Pataleshwar Temple stands as Pune’s timeless link to its ancient spiritual roots."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts showcasing India’s rich cultural heritage. From antique musical instruments to intricate carvings and rare household items, it’s a treasure trove of history. Founded by Dr. D.G. Kelkar, the museum celebrates India’s artistic excellence. It’s one of Pune’s most fascinating destinations for culture enthusiasts."
  },
  {
    "title": "Osho Ashram (Osho International Meditation Resort)",
    "description": "Located in Koregaon Park, Osho Ashram is a global meditation center attracting visitors seeking peace and transformation. Surrounded by lush greenery and tranquil gardens, it offers meditation sessions, yoga, and wellness therapies. The ashram’s modern design and spiritual vibe create a unique experience. Osho Ashram is Pune’s international hub for inner healing and mindfulness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular weekend getaway just outside Pune, offering serene lakeside views and breezy weather. It supplies water to the city and provides a scenic backdrop for picnics and evening drives. Visitors enjoy street food stalls and photography near the lake. Khadakwasla is Pune’s peaceful escape into nature."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s Korakuen Garden, is a beautifully landscaped park in Sinhagad Road. With its flowing streams, manicured lawns, and traditional Japanese design, it offers a tranquil environment for nature lovers. Families and couples stroll along its bridges and pathways. It symbolizes Pune’s connection to global harmony and natural beauty."
  }
],



      "services": [
    {
      "name": "17 Seater Urbania Hire in Pune",
      "description": "17 Seater Urbania Hire in Pune offers spacious and reliable van rentals ideal for larger groups, corporate teams, and family outings. These vans provide ample seating and luggage space, ensuring comfort and convenience for city travel, day trips, and special events. With professional drivers well-versed in Pune’s traffic patterns, this service guarantees punctual pickups, smooth rides, and excellent customer support for a stress-free experience."
    },
    {
      "name": "Force Urbania 17 Seater Pune",
      "description": "Force Urbania 17 Seater Pune specializes in renting the trusted Force Urbania vans known for their durability and comfortable seating. Popular among group travelers and businesses alike, these vans undergo regular maintenance and safety checks. Experienced chauffeurs provide reliable, timely service for urban and outstation travel, ensuring customer satisfaction through professional and courteous driving."
    },
    {
      "name": "AC 17 Seater Urbania Pune",
      "description": "AC 17 Seater Urbania Pune ensures a cool and pleasant journey with fully air-conditioned vans, perfect for Pune’s warm climate. This service is tailored for clients looking for a comfortable and premium travel experience, whether commuting to corporate meetings, airport transfers, or leisure tours. Vehicles are equipped with modern AC systems and comfortable interiors, with courteous drivers focused on passenger comfort and safety."
    },
    {
      "name": "Non AC 17 Seater Urbania Pune",
      "description": "Non AC 17 Seater Urbania Pune provides economical and reliable group transport options without air conditioning. Ideal for budget-conscious travelers or short trips within the city, these vans maintain high standards of cleanliness, safety, and reliability. Professional drivers ensure timely service and a comfortable ride even without AC, making it a practical choice for many customers."
    },
    {
      "name": "Luxury Urbania 17 Seater Pune",
      "description": "Luxury Urbania 17 Seater Pune offers premium van rentals with upscale interiors, enhanced seating comfort, and additional amenities designed for weddings, corporate events, and special occasions. These vans feature plush seating, elegant finishes, and attentive chauffeurs providing discreet and exceptional service. The focus is on delivering a luxurious and memorable travel experience for discerning clients."
    },
    {
      "name": "Urbania Hire Hadapsar",
      "description": "Urbania Hire Hadapsar caters specifically to residents and businesses in the Hadapsar area, providing well-maintained 17 seater vans for various group transportation needs. Whether for office commutes, social events, or airport transfers, this service offers flexible booking, reliable vehicles, and experienced drivers ensuring safe and timely travel within and beyond Hadapsar."
    },
    {
      "name": "Urbania Hire Baner",
      "description": "Urbania Hire Baner offers convenient and dependable 17 seater van rentals for the Baner locality. Ideal for family outings, corporate events, and group tours, this service is known for punctuality, vehicle cleanliness, and professional driver behavior. It provides customized travel solutions to suit the specific requirements of Baner’s dynamic population."
    },
    {
      "name": "Urbania Hire Hinjewadi",
      "description": "Urbania Hire Hinjewadi specializes in providing efficient van rental services for the IT and corporate hub of Hinjewadi. These 17 seater vans are popular among corporate clients, IT professionals, and business groups for daily commutes and client visits. The service emphasizes on-time pickups, clean and comfortable vehicles, and courteous drivers familiar with local traffic conditions."
    },
    {
      "name": "Urbania Hire Pimpri",
      "description": "Urbania Hire Pimpri provides reliable and affordable 17 seater van rentals for the Pimpri area. This service suits employee transportation, group outings, and business travel, offering well-maintained vans and experienced chauffeurs who prioritize safety and timely service. Flexible rental packages accommodate both short and long-term transportation needs."
    },
    {
      "name": "Corporate Urbania Hire Pune",
      "description": "Corporate Urbania Hire Pune delivers professional van rental solutions for businesses requiring efficient and comfortable transport for employees, clients, and corporate events. With a fleet of clean, well-equipped 17 seater vans and skilled drivers, this service supports corporate schedules with punctuality, professionalism, and flexibility in rental terms."
    },
    {
      "name": "Wedding Urbania Pune",
      "description": "Wedding Urbania Pune specializes in providing elegant and beautifully maintained vans for weddings, receptions, and related events. The service offers timely pickups and drop-offs, well-decorated vehicles on request, and attentive chauffeurs to ensure smooth logistics and a touch of luxury on your special day, enhancing the overall wedding experience."
    },
    {
      "name": "Outstation Urbania Pune",
      "description": "Outstation Urbania Pune offers long-distance van rental services for group travel beyond Pune, including tours, business trips, and leisure journeys to neighboring cities and tourist destinations. These 17 seater vans are equipped for comfort over extended distances with spacious seating, adequate luggage capacity, and drivers skilled in managing intercity routes to ensure safe and punctual travel."
    },
    {
      "name": "Affordable 17 Seater Urbania Pune",
      "description": "Affordable 17 Seater Urbania Pune focuses on providing cost-effective van rental options that do not compromise on quality or safety. Targeted at budget-conscious groups and individuals, this service ensures transparent pricing, well-maintained vehicles, and flexible booking options for local and outstation travel. It is a popular choice for schools, small corporate groups, and families."
    },
    {
      "name": "Urbania Booking Online Pune",
      "description": "Urbania Booking Online Pune offers a convenient and user-friendly digital platform for reserving 17 seater Urbania vans. Customers enjoy instant booking confirmations, multiple payment options, customizable routes, and 24/7 customer support. This seamless online service caters to the modern traveler's need for quick, hassle-free reservations across Pune."
    },
    {
      "name": "Urbania Hire near Me Pune",
      "description": "Urbania Hire near Me Pune provides localized access to 17 seater Urbania vans across Pune, ensuring prompt availability for immediate or scheduled travel. This service emphasizes quick response times, flexible rental durations, and professional drivers to deliver safe and comfortable rides, making group travel convenient and accessible throughout the city."
    },
    {
      "name": "Force Urbania Rental Pune",
      "description": "Force Urbania Rental Pune offers robust and spacious Force Urbania vans for rent, known for their reliability and passenger comfort. This service caters to groups requiring durable vehicles with sufficient seating and luggage space for various occasions, including city travel and outstation trips. Regular maintenance and expert drivers guarantee safe and efficient transportation."
    },
    {
      "name": "Urbania Tour Van Pune",
      "description": "Urbania Tour Van Pune provides specially equipped 17 seater vans for sightseeing tours, group excursions, and leisure travel around Pune and nearby attractions. These vans offer comfortable seating, ample luggage space, and knowledgeable drivers who often double as local guides, ensuring a relaxed and informative travel experience tailored to tourists and groups."
    },
    {
      "name": "Premium Urbania Pune",
      "description": "Premium Urbania Pune features high-end 17 seater vans with superior interiors, advanced amenities, and exceptional driver service. Designed for clients who seek luxury and comfort for business travel, weddings, and VIP group outings, this service guarantees an elevated travel experience marked by elegance, punctuality, and personalized attention to detail."
    }
  ],
  "tableData": [
    ["17 Seater Urbania Hire in Pune", "Force Urbania 17 Seater Pune"],
    ["AC 17 Seater Urbania Pune", "Non AC 17 Seater Urbania Pune"],
    ["Luxury Urbania 17 Seater Pune", "Urbania Hire Hadapsar"],
    ["Urbania Hire Baner", "Urbania Hire Hinjewadi"],
    ["Urbania Hire Pimpri", "Corporate Urbania Hire Pune"],
    ["Wedding Urbania Pune", "Outstation Urbania Pune"],
    ["Affordable 17 Seater Urbania Pune", "Urbania Booking Online Pune"],
    ["Urbania Hire near Me Pune", "Force Urbania Rental Pune"],
    ["Urbania Tour Van Pune", "Premium Urbania Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "17 Seater Urbania Hire in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers spacious and reliable 17 seater Urbania hire services in Pune, perfect for group travel and comfortable city rides."
  },
  {
    "WhyChooseheading": "Regularly Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our 17 seater Urbania vans are routinely serviced and thoroughly cleaned to ensure your safety and comfort."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Benefit from upfront rental rates with no hidden costs, inclusive of all taxes and fees."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental options tailored to meet your specific travel needs."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our courteous drivers ensure a safe, punctual, and pleasant journey every time."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist with bookings, inquiries, and travel arrangements."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your 17 seater Urbania easily online or via phone, with prompt vehicle delivery anywhere in Pune."
  },
  {
    "WhyChooseheading": "Customer Satisfaction Commitment",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd is dedicated to providing reliable, comfortable, and hassle-free group travel experiences."
  }
]





























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer 17 seater Urbania hire services in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides 17 seater Urbania hire services in Pune, perfect for medium-sized group travel and events.',
  },
  {
    question: 'How can I book a 17 seater Urbania for hire in Pune with Amruta Travels?',
    answer: 'Booking is easy through our website, mobile app, or by contacting our 24x7 customer support team in Pune.',
  },
  {
    question: 'What amenities are available in the 17 seater Urbania vehicles in Pune?',
    answer: 'Our 17 seater Urbania vehicles are equipped with comfortable seating, air conditioning, and essential safety features for a pleasant ride.',
  },
  {
    question: 'Are the drivers trained and experienced for 17 seater Urbania hires in Pune?',
    answer: 'Absolutely. Our drivers are professional, courteous, and experienced in driving 17 seater Urbania vehicles safely.',
  },
  {
    question: 'Can 17 seater Urbania vehicles be hired for weddings, corporate events, and tours in Pune?',
    answer: 'Yes, these vehicles are ideal for weddings, corporate outings, airport transfers, and sightseeing tours in Pune.',
  },
  {
    question: 'Is the 17 seater Urbania hire service available 24x7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24x7 availability for 17 seater Urbania hire services to suit your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for 17 seater Urbania hires?',
    answer: 'All vehicles are thoroughly sanitized before every trip, and drivers adhere to strict hygiene and safety protocols.',
  },
  {
    question: 'What are the payment options for 17 seater Urbania hire in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the 17 seater Urbania hire period in Pune?',
    answer: 'Yes, our 24x7 customer support team is available to assist you at any time during your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Deshpande',
    feedback: 'The 17 seater Urbania from Amruta Travels Pune was spacious and comfortable. The driver was punctual and very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Joshi',
    feedback: 'Great experience with Amruta Travels. The 17 seater Urbania was perfect for our corporate event in Pune.',
    rating: 5,
  },
];




























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Urbania Hire in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/5.jpg",
  "description": "Book a 17 Seater Urbania Hire in Pune with Amruta Travels Pvt. Ltd. offering premium, comfortable, and affordable Force Urbania vans. Available in AC, Non-AC, and Luxury options for corporate trips, weddings, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "10891"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2900",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/17-seater-urbania-hire-in-pune"
  }
};






  return (
    <div>

<Helmet>
  <title>17 Seater Urbania Hire in Pune | Force Urbania Luxury Van | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book 17 Seater Urbania Hire in Pune with Amruta Travels Pvt. Ltd. offering AC, Non-AC, and Luxury Force Urbania vans for corporate, wedding, and outstation travel. Reliable and affordable Urbania rental services in Pune."
  />
  <meta
    name="keywords"
    content="17 Seater Urbania Hire in Pune, Force Urbania 17 Seater Pune, AC 17 Seater Urbania Pune, Non AC 17 Seater Urbania Pune, Luxury Urbania 17 Seater Pune, Urbania Hire Hadapsar, Urbania Hire Baner, Urbania Hire Hinjewadi, Urbania Hire Pimpri, Corporate Urbania Hire Pune, Wedding Urbania Pune, Outstation Urbania Pune, Affordable 17 Seater Urbania Pune, Urbania Booking Online Pune, Urbania Hire near Me Pune, Force Urbania Rental Pune, Urbania Tour Van Pune, Premium Urbania Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onesevanurbaniahireinpune;